// extracted by mini-css-extract-plugin
export default {"header":"index_header_aFPBs","header_bar":"index_header_bar_0x9wk clearfix","user":"index_user_ZkATj","search":"index_search_svI-O","box":"index_box_TK0Sf"};